import { render, staticRenderFns } from "./AuthApp.vue?vue&type=template&id=773cb0fb&"
import script from "./AuthApp.vue?vue&type=script&lang=js&"
export * from "./AuthApp.vue?vue&type=script&lang=js&"
import style0 from "./AuthApp.vue?vue&type=style&index=0&id=773cb0fb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports